/**
 * Utilidades para generar y manejar UUIDs
 * Para integración con backend de NumeCALENDAR
 */

/**
 * Genera un UUID v4 válido según RFC4122
 * @returns {string} UUID en formato: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
 */
export function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

/**
 * Obtiene o crea un UUID para el perfil principal del usuario
 * Se guarda en localStorage para persistencia
 * @returns {string} UUID del perfil
 */
export function getOrCreateProfileId() {
  let profileId = localStorage.getItem('profileId');
  
  if (!profileId) {
    profileId = generateUUID();
    localStorage.setItem('profileId', profileId);
    console.log('✅ Nuevo profileId creado:', profileId);
  }
  
  return profileId;
}

/**
 * Obtiene o crea UUID para un perfil ninja
 * @param {string} ninjaKey - Identificador único del perfil ninja (ej: nombre + fecha)
 * @returns {string} UUID del perfil ninja
 */
export function getOrCreateNinjaProfileId(ninjaKey) {
  const storageKey = `ninjaProfile_${ninjaKey}`;
  let profileId = localStorage.getItem(storageKey);
  
  if (!profileId) {
    profileId = generateUUID();
    localStorage.setItem(storageKey, profileId);
    console.log('✅ Nuevo ninjaProfileId creado:', profileId);
  }
  
  return profileId;
}

/**
 * Valida si un string es un UUID válido
 * @param {string} uuid - String a validar
 * @returns {boolean} true si es UUID válido
 */
export function isValidUUID(uuid) {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(uuid);
}

/**
 * Limpia todos los UUIDs guardados (útil para testing)
 */
export function clearAllProfileIds() {
  localStorage.removeItem('profileId');
  
  // Limpiar también perfiles ninja
  const keys = Object.keys(localStorage);
  keys.forEach(key => {
    if (key.startsWith('ninjaProfile_')) {
      localStorage.removeItem(key);
    }
  });
  
  console.log('🗑️ Todos los profileIds limpiados');
}

